import React from 'react';
import ZoneLinks from '../ZoneLinks';
import { WEBSITE_LOCAL_PAGES } from '../../data/websiteLocalPages';

const ZONE_LINKS = WEBSITE_LOCAL_PAGES.map((p) => ({ label: p.shortName, to: p.path }));

const OfferLocalLinks: React.FC = () => (
  <ZoneLinks
    id="zones-intervention"
    title="Zones d'intervention"
    intro="Je crée des sites internet pour les indépendants et les petites entreprises de ces secteurs. Choisissez le vôtre pour voir la page dédiée."
    links={ZONE_LINKS}
  />
);

export default OfferLocalLinks;
